import { offerCoverImage } from '../offerImages';
import React from "react";
import OfferContent from "./components/OfferContent";
import OfferCover from "./components/OfferCover";
import OfferHeader from "./components/OfferHeader";
import OfferMeta from "./components/OfferMeta";
import OfferActions from "../OfferActions";
import { offerAvailabilitySx } from '../utils';
import { StyledCard, AutoHeightBox } from "./styles";

const OfferCard = ({
  active,
  id,
  description,
  claimsRemaining,
  unlimitedClaims = false,
  termsAndConditions,
  distance,
  endDate,
  imageUrl,
  businessId,
  businessImageUrl,
  businessName,
  headline1,
  headline2,
  isPreview,
  phone,
  showPhone,
  address,
  showAddress,
  offerLocation,
  revalidateList,
  beforeClaimAction,
  hideLocation,
  allowUnavailableActions = false,
  grayOutUnavailable = true,
  showUnavailableLabels = false,
}) => {
  return (
    <StyledCard sx={grayOutUnavailable ? offerAvailabilitySx(active, isPreview) : {}}>
      <OfferCover isPreview={isPreview} companyImage={businessImageUrl} image={offerCoverImage(imageUrl, isPreview)} company={businessId} />
      <AutoHeightBox>
        <OfferHeader 
          h1={headline1} 
          h2={headline2}
          hideLocation={hideLocation}
          location={
            // Always use distance if provided (matches the Summary table location)
            // Only show fallback if distance is not provided or is the placeholder
            (distance && distance !== '{dynamic location}') 
              ? distance 
              : (isPreview ? '{dynamic location}' : 'Global')
          } 
        />
        <OfferContent>{description}</OfferContent>
      </AutoHeightBox>
      <OfferMeta
        isPreview={isPreview && claimsRemaining === undefined && !unlimitedClaims}
        quantity={claimsRemaining}
        unlimitedClaims={unlimitedClaims}
        endDate={endDate}
        active={active}
        showUnavailableLabels={showUnavailableLabels}
      />
      <OfferActions
        compact
        active={active}
        businessImageUrl={businessImageUrl}
        businessName={businessName}
        claimsRemaining={claimsRemaining}
        description={description}
        termsAndConditions={termsAndConditions}
        distance={distance}
        endDate={endDate}
        headline1={headline1}
        headline2={headline2}
        id={id}
        imageUrl={imageUrl}
        isPreview={isPreview}
        phone={phone}
        showPhone={showPhone}
        address={address}
        showAddress={showAddress}
        offerLocation={offerLocation}
        revalidateList={revalidateList}
        beforeClaimAction={beforeClaimAction}
        allowUnavailableActions={allowUnavailableActions}
      />
    </StyledCard>
  );
};

export default OfferCard;
